import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HolidaySummary from "app/pages/Booking/HolidaySummary/HolidaySummary/HolidaySummary";
import {
	calculateInboundArrivalDayCount,
	calculateOutboundArrivalDayCount,
} from "app/pages/Booking/bookingSelectors";
import { matchPath, withRouter } from "react-router-dom";
import { checkForSpecialOffer } from "app/pages/Booking/Payment/paymentSelector";
import get from "lodash/get";
import { OFFER_TYPES } from "app/constants";
import isEmpty from "lodash/isEmpty";

const mapStateToProps = (state, props) => {
	const currentPathname = props.location.pathname;

	const isConfirmationPage = matchPath(currentPathname, {
		path: "/booking/confirmation",
	});

	const isSDPPaymentPage = matchPath(currentPathname, {
		path: "/sdp/booking/payment",
	});

	const isPaymentPage = matchPath(currentPathname, {
		path: "/booking/payment",
	});

	const isSDPConfirmationPage = matchPath(currentPathname, {
		path: "/sdp/booking/confirmation",
	});

	const isSDPQuote = matchPath(currentPathname, {
		path: "/sdp/booking/quote",
	});

	const isQuote = matchPath(currentPathname, {
		path: "/booking/quote",
	});

	const isSDP = isSDPQuote || isSDPPaymentPage || isSDPConfirmationPage;

	const partnerCode = state.partner.code;

	const booking = state.booking || {};

	return {
		isSDP,
		ficheProduit: state.ficheProduit,
		booking: booking,
		inboundArrivalDayCount: calculateInboundArrivalDayCount(state),
		outboundArrivalDayCount: calculateOutboundArrivalDayCount(state),
		showTimer: !isSDP && partnerCode !== "VPDE" && partnerCode !== "PSVP",
		hasSdpSpecialOffer: checkForSpecialOffer(state), // true si le back renvoi au moins un vol remboursable
		specialOfferInfos: state.ficheProduit.specialOffer,
		showFlightDetails:
			(isQuote ||
				isSDPQuote ||
				isPaymentPage ||
				isSDPPaymentPage ||
				isConfirmationPage ||
				isSDPConfirmationPage) &&
			get(booking, "offer.type") === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION &&
			!isEmpty(booking.flight),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({}, dispatch);
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(HolidaySummary)
);
